<template>
  <div class="card chart-card">
    <div class="card-header">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex">
            <div class="card-title dashboard-cards-header">
              <el-select
                class="dashboardCategoryDropdown-el-select dashboardCategoryDropdown1 dashboardCategoryDropdownBubble-el-select select-primary"
                size="small"
                placeholder="Select Gain & Loss Graph"
                @change="categoryChange"
                v-model="category.selected"
              >
                <el-option
                  v-for="option in categoryDropdown"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div style="margin-top: auto;margin-bottom: auto;" v-tooltip.top-end="toolTipInfo">
              <img src="static/img/graphInfo.svg" class />
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex">
            <div>
              <el-select
                class="dashboard-dropdown-el-select select-primary"
                size="small"
                placeholder="Select Gain & Loss Graph"
                v-model="subCategoryDropDownSelected.selected"
              >
                <el-option
                  v-for="option in subCategoryDropDown"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </div>
            <div>
              <input
                class="todo-form-date todo-form form-control"
                style="margin-bottom:0px !important;height:26px;padding:0px 5px;width:121px"
                type="date"
                v-model="fromDate"
                @change="fromDateChange($event)"
              />
            </div>
            <div style="margin-left:10px;">
              <input
                class="todo-form-date todo-form form-control"
                style="margin-bottom:0px !important;height:26px;padding:0px 5px"
                type="date"
                :min="fromDate"
                :max="todayDate"
                v-model="toDate"
                @change="toDateChange($event)"
              />
              <div class="d-flex justify-content-end">
                <div
                  class="funnelDateReset"
                  :style="(toDate.length>0 || fromDate.length>0)?'visibility:visible':'visibility:hidden'"
                  @click="changeData"
                >Reset</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="padding: 0px 10px 0px 0px;">
      <div class="card-box">
        <chartjs-bubble :chartData="chartData" :chartOptions="chartOptions" :style="lineChartStyle">
          <!--style="width:80%;display:block;margin-left:auto;margin-right:auto"-->
        </chartjs-bubble>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "../Card.vue";
import ChartjsBubble from "../../Chartjs/ChartjsBubble";
import util from "util";
import { mapGetters } from "vuex";
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import _ from "lodash";
export default {
  name: "bubbleGainLossChartCard",
  components: {
    Card,
    ChartjsBubble,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  computed: {
    ...mapGetters("charts", [
      "dashboardBubbleByProperty",
      "dashboardBubbleChartByProperty",
    ]),
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("user", ["currency"]),
    lineChartStyle() {
      return {
        position: "relative",
      };
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              //let label = data.datasets[toolTipItem.datasetIndex].label || "";
              let label = data.labelsUnaltered[toolTipItem.datasetIndex] || "";
              // let key =
              //   self.subCategoryDropDownSelected.selected == "all"
              //     ? `${label} (average)`
              //     : label;
              let value =
                data.datasets[toolTipItem.datasetIndex].data[toolTipItem.index]
                  .y || 0;
              // return (
              //   (data.datasets[toolTipItem.datasetIndex].label || "") +
              //     ": " +
              //     data.datasets[toolTipItem.datasetIndex].data[
              //       toolTipItem.index
              //     ].y || 0
              // );
              if (
                self.subCategoryDropDownSelected.selected == "all" &&
                self.category.selected != "name"
              ) {
                return `${label} : Average of ${value} x`;
              }
              return `${label} : ${value} x`;
            },
            // footer: function (toolTips, data) {
            //   if (self.subCategoryDropDownSelected.selected == "all") {
            //     return "(average)";
            //   }
            // },
          },
        },
        legend: {
          display: false,
        },
        layout: {
          padding: 10,
        },
        scales: {
          xAxes: [
            {
              bounds: "ticks",
              //   type: "time",
              //   distribution: "series",
              //   bounds: "ticks",
              //   time: {
              //     tooltipFormat: "ll",
              //     round: "day",
              //     unit: "day",
              //     displayFormats: {
              //       day: "ll",
              //     },
              //   },
              //type: "linear",
              //labels: self.xAxesLabels,
              beforeBuildTicks: function (axis) {
                let ticksArray = axis.chart.config.data.labels;
                axis._ticks = [];
                axis.ticks = [];
                ticksArray.map((item, index) => {
                  axis._ticks.push(index);
                  axis.ticks.push(index);
                });
                //axis._ticks = axis.chart.config.data.labels;
                //axis.ticks = axis.chart.config.data.labels;
                return axis;
              },
              afterBuildTicks: function (axis, ticks) {
                // let _ticks = axis.chart.config.data.labels;
                // axis._ticks = [];
                // axis.ticks = [];
                // _ticks.map((item) => {
                //   let obj = {};
                //   obj.label = item;
                //   obj.major = false;
                //   axis._ticks.push(obj);
                //   axis.ticks.push(obj);
                // });
                //axis._ticks = axis.chart.config.data.labels;
                axis.ticks = axis._ticks;
                ticks = axis.ticks;
                return axis._ticks;
              },
              // position: 'bottom',
              ticks: {
                //position: 'bottom',
                callback: function (value, index, values) {
                  return this.chart.config.data.labels[index];
                },
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return `${value} x`;
                },
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      if (this.category.selected == "sector") {
        return "This plot chart shows your multiple gain & loss by sector as an average selected on the left. Each sub sector selected on the right will show each companies individual multiple.";
      }
      if (this.category.selected == "stage") {
        return "This plot chart shows your multiple gain & loss by stage as an average selected on the left. Each sub stage selected on the right will show each companies individual multiple.";
      }
      if (this.category.selected == "geography") {
        return "This plot chart shows your multiple gain & loss by geography as an average selected on the left. Each sub geography selected on the right will show each companies individual multiple.";
      }
      if (this.category.selected == "status") {
        return "This plot chart shows your multiple gain & loss by status as an average selected on the left. Each sub status selected on the right will show each companies individual multiple.";
      }
      if (this.category.selected == "name") {
        return "This plot chart shows your multiple gain & loss by company on the left. Each company selected on the right will show each companies individual multiple.";
      }
    },
    todayDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
    categoryDropdown() {
      let dropDownArray = [];
      dropDownArray[0] = { label: "Multiple By Sector", value: "sector" };
      dropDownArray[1] = { label: "Multiple By Stage", value: "stage" };
      dropDownArray[2] = {
        label: "Multiple By Geography",
        value: "geography",
      };
      dropDownArray[3] = { label: "Multiple By Status", value: "status" };
      dropDownArray[4] = { label: "Multiple By Company", value: "name" };
      return dropDownArray;
    },
    subCategoryDropDown() {
      let subCategory = this.dashboardBubbleChartByProperty(
        this.category.selected,
        this.subCategoryDropDownSelected.selected
      )[this.category.selected];
      let retval = [];
      retval[0] = {
        label:
          this.category.selected == "sector" ||
          this.category.selected == "stage"
            ? `All ${
                this.category.selected.charAt(0).toUpperCase() +
                this.category.selected.slice(1)
              }s`
            : this.category.selected == "name"
            ? "All Companies"
            : `All ${
                this.category.selected.charAt(0).toUpperCase() +
                this.category.selected.slice(1)
              }`,
        value: "all",
      };
      subCategory.map((item) => {
        let obj = {};
        obj.label = item;
        obj.value = item;
        retval.push(obj);
      });
      return retval;
    },
    chartData() {
      const self = this;
      //let portfolioInfo = self.portfolioROIByProperty(self.category.selected);
      let portfolioInfo = self.dashboardBubbleChartByProperty(
        self.category.selected,
        self.subCategoryDropDownSelected.selected
      );
      self.category.title = _.has(vals.HEADER_MAP, self.category.selected)
        ? vals.HEADER_MAP[self.category.selected]
        : _.startCase(self.category.selected);
      let labels = portfolioInfo[self.subCategoryDropDownSelected.selected];
      let truncatedLabels = _.map(labels, (lbl) => {
        return lbl.length > 12 ? _.truncate(lbl, { length: 12 }) : lbl;
      });
      self.xAxesLabels = labels;
      let retval = {
        labels: truncatedLabels,
        datasets: [],
        labelsUnaltered: labels,
      };
      let multiples = portfolioInfo.multiple;
      multiples.map((item, index) => {
        let obj = {};
        let data = [];
        let multiple = 0;
        multiple = item && Number(item) > 0 ? Number(item) : 0;
        obj.label =
          labels && labels.length > 0 && labels[index] ? labels[index] : "";
        obj.backgroundColor =
          multiple && multiple > 1
            ? "#73D600"
            : multiple == 1
            ? "#006CFF"
            : "#fff";
        if (multiple < 1) {
          obj.borderColor = "#24A8FD";
          obj.borderWidth = 2;
        }
        data[0] = {
          x: index,
          y: Number(multiple),
          r: 5,
        };
        obj.data = data;
        retval.datasets.push(obj);
      });
      return retval;
    },
  },
  data() {
    return {
      toDate: "",
      fromDate: "",
      category: {
        selected: "name",
        title: "Company",
      },
      categoryDropDownSelected: {
        selected: "name",
        title: "Multiple by Company",
      },
      subCategoryDropDownSelected: {
        selected: "all",
      },
      xAxesLabels: [],
    };
  },
  methods: {
    // chartData() {
    //   const self = this;
    //   let data = self.$store.getters["charts/dashboardBubbleByProperty"];
    //   console.log("dashboardBubbleByProperty", data);
    //   return data;
    // },
    fromDateChange(event) {
      this.$store.commit("charts/setBubbleFromDate", event.target.value);
      this.$store.commit("charts/setBubbleToDate", "");
      this.toDate = "";
      //this.chartData();
    },
    toDateChange(event) {
      this.$store.commit("charts/setBubbleToDate", event.target.value);
      //this.chartData();
    },
    changeData() {
      this.toDate = "";
      this.fromDate = "";
      this.$store.commit("charts/setBubbleFromDate", "");
      this.$store.commit("charts/setBubbleToDate", "");
      //this.chartData();
    },
    categoryChange() {
      this.subCategoryDropDownSelected.selected = "all";
    },
  },
  props: {
    defaultSelected: {
      type: String,
      default() {
        return undefined;
      },
    },
  },
  mounted() {
    const self = this;
    self.changeData();
    if (!_.isNil(self.defaultSelected)) {
      self.category.selected = self.defaultSelected;
      self.category.title = _.has(vals.HEADER_MAP, self.defaultSelected)
        ? vals.HEADER_MAP[self.defaultSelected]
        : _.startCase(self.defaultSelected);
      self.categoryChange();
    }
  },
};
</script>
<style>
</style>
